import Image from 'next/image';
import React from 'react';
import infoIcon from '@assets/images/info-icon-red.svg';

type Props = {
  text: string;
  showInfoIcon?: boolean;
};

const defaultProps = {
  showInfoIcon: false,
};

export default function FormErrorText({ showInfoIcon, text }: Props) {
  return (
    <div className="flex items-center font-medium font-rp-pn-regular justify-center leading-6 text-center text-rp-danger-2 text-sm">
      {showInfoIcon && (
        <div className="flex mr-2 relative flex-shrink-0">
          <Image src={infoIcon} alt="Info" />
        </div>
      )}

      <p>{text}</p>
    </div>
  );
}

FormErrorText.defaultProps = defaultProps;
